import { render, staticRenderFns } from "./CourseSettingsForm.vue?vue&type=template&id=1f6dbc69&"
import script from "./CourseSettingsForm.vue?vue&type=script&lang=js&"
export * from "./CourseSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports